export default class UtilMarker {

    /**
     * @param {Object} marker
     * @param {String} color
     * @param {Array} selectedIds
     * @returns {Object}
     */
    static prepareWithoutPriceMarker(marker, color, selectedIds = []) {
        let selected = false;

        Object.values(marker?.catalog_sides ?? {}).forEach((catalogId) => {
            if(selectedIds.includes(catalogId)){
                selected = true;
            }
        })

        marker.selected = selected;
        marker.status = 'without_price';
        marker.extraData.status = marker.status;
        marker.extraData.catalogSides = marker.catalog_sides
        marker.fill_color = color;

        return marker;
    }

    /**
     * Адаптер для маркеров
     * @param {Array} markers - маркеры
     * @param {String} color - цвет
     * @param {String} kitId - идентификатор набора
     * @param {Boolean} selected - условие выбранности маркера
     * @param {String} iconType - тип иконки
     * @returns {Array}
     */
    static adapterMarkers(
        markers = [],
        color = '',
        kitId = '-1',
        selected = false,
        iconType = 'default'
    ) {
        const markersAdapted = markers.map(marker => {
            const {side_ids = [], status = '', fill_color = '', colors = {}, side_status: sideStatus = {}, side_names: sideNames = []} = marker;

            const sideNamesCurrent = String(kitId) === '0' ? Object.keys(sideStatus) : sideNames

            const sidesColors = sideNamesCurrent.reduce((sidesColors, sideKey) => {
                return {
                    ...sidesColors,
                    [sideKey]: colors[sideKey] ?? color
                };
            }, {});

            return  {
                ...marker,
                additionalId: String(kitId),
                clusterType: 'default',
                extraData: {
                    ...marker,
                    kitId,
                    sideIds: side_ids,
                    status,
                    sideStatus
                },
                fill_color: color,
                status,
                color_legend: fill_color,
                selected,
                sidesColors,
                iconType
            };
        });
        return markersAdapted;
    }

    /**
     * Get legend key by kit id
     * @param kitId
     * @returns {string}
     */
    static getLegendKeyByKitId(kitId) {
        switch (true){
            case String(kitId) === '0':
                return  'found';
            case String(kitId) === '-2':
                return 'without_prices';
            default:
                return 'custom';
        }
    }

    static updateMarkerVisibility(marker = {}) {
        if (marker.sidesFiltered.length > 0) {
            marker.isVisible = true;
            marker.updateIcon(marker.iconType, false);
            marker.drawMarker();
        } else {
            marker.isVisible = false;
            marker.clearMarker();
        }
    }

    static resolveGroupId(id, legendKey, attribute) {
        let groupId = String(id).split('--')[2] ?? '';
        if (legendKey === 'without_prices' && attribute === 'default') {
            groupId = '-2';
        }
        return groupId;
    }
}
